<template>
    <div>
        <CFTitle title="17. Nerespectare legislație UE"></CFTitle>

        <p class="question">Proiectul face obiectul unei proceduri juridice pentru nerespectarea legislatiei uniunii?</p>
        <div style="display: flex">
            <div style="display: flex">
                <span class="answer">Da</span><b-form-radio v-model="form.nerespectareLegislatie" name="nerespectareLegislatie" :value="true" :disabled="completed" @change="warnChange()"></b-form-radio>
            </div>
            <div style="display: flex">
                <span class="answer">Nu</span><b-form-radio v-model="form.nerespectareLegislatie" name="nerespectareLegislatie" :value="false" :disabled="completed" @change="warnChange()"></b-form-radio>
            </div>
        </div>

        <p class="question">Întreprinderea a fost in trecut supusa sau este in prezent supusa unei proceduri de recuperare a sprijinului uniunii ca urmare a delocalizarii unei activitati de productie in afara zonei avizate de program?</p>
        <div style="display: flex">
            <div style="display: flex">
                <span class="answer">Da</span><b-form-radio v-model="form.recuperareSprijin" name="recuperareSprijin" :value="true" :disabled="completed" @change="warnChange()"></b-form-radio>
            </div>
            <div style="display: flex">
                <span class="answer">Nu</span><b-form-radio v-model="form.recuperareSprijin" name="recuperareSprijin" :value="false" :disabled="completed" @change="warnChange()"></b-form-radio>
            </div>
        </div>
        <hr class="mt-4">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormCheckbox, BFormRadio } from "bootstrap-vue";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'

    export default {
        name: "CFNerespectareLegislatieUE",
        components: {
            BFormCheckbox,
            BFormRadio,
            CFTitle,
            M3Warn,
        },
        props:{
            data: {
                type: Object,
                default: null
            },
            m3GrantApplication: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                form: {
                    nerespectareLegislatie: false,
                    recuperareSprijin: false
                },
                completed: null,
            }
        },
        computed:{
            isCompleted() {
                return this.$store.getters['finantare/progress'].includes('Nerespectare legislatie UE');
            },
        },
        watch: {
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.nerespectare_legislatie){
                        this.form = this.m3GrantApplication.nerespectare_legislatie;
                    }
                },
                deep: true
            },
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.nerespectare_legislatie){
                this.form = this.m3GrantApplication.nerespectare_legislatie;
            }
        },
        methods: {
            sendForm(){
                if(this.completed){
                    axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {nerespectare_legislatie: this.form})
                        .then( () => {
                            this.$store.dispatch('finantare/addToProgress', 'Nerespectare legislatie UE')
                            this.$toast.success('Informațiile au fost salvate!')
                            this.$emit('savedData')
                        })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Nerespectare legislatie UE')
                }
            },
            warnChange() {
                this.$toast.error('Îți recomandăm să nu modifici aceste răspunsuri')
            }
        }
    }
</script>

<style scoped>
.question{
  margin-top: 20px;
  font-size: 14px;
}
.answer{
  margin-left: 20px;
  margin-right: 10px;
}
</style>
